import { Component, ViewEncapsulation, Inject, ElementRef, OnInit } from "@angular/core";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { Router } from "@angular/router";
import { AppState } from "@toro/common/shared/interfaces/app-state.interface";
import { Store } from "@ngrx/store";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SidePanelService } from "../../features/side-panel/services/side-panel.service";
import { CheckoutReviewComponent } from "../../../components/checkout-review/checkout-review.component";
import { getSantanderEnumFromString, SantanderSuitabilityEnum } from "../../../enum/santander-suitability.enum";

@Component({
  selector: "success-aside-panel",
  templateUrl: "./success-aside-panel.component.html",
  styleUrls: ["success-aside-panel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SuccessAsidePanelComponent extends DialogPanelComponentContent {
  protected santanderSuitabilityProfile: SantanderSuitabilityEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public elementRef: ElementRef,
    private sidePanelService: SidePanelService,
    private dialogReference: MatDialogRef<SuccessAsidePanelComponent>,
    private router: Router,
    private store: Store<AppState>,
  ) {
    super(elementRef, true);
    this.santanderSuitabilityProfile = this.data.suitability
  }

  public get isNotArrojado(): boolean {
    return this.santanderSuitabilityProfile !== SantanderSuitabilityEnum.ARROJADO;
  }

  public get santanderSuitabilityProfileToString(): string {
    const profile = this.santanderSuitabilityProfile?.toLowerCase() || '';
    return profile.charAt(0).toUpperCase() + profile.slice(1);
  }

  public redirectExternal(url: string) {
    window.location.href = `${url}`;
  }

  public redirectMyInvestments() {
    this.close(this.dialogReference, null);
    return this.router.navigateByUrl("/meus-investimentos");
  }

  public redirectStocks() {
    this.close(this.dialogReference, null);
  }

  public checkoutReview(): void {
    const checkoutData = {
      purchase: this.data.purchase,
    }

    this.close(this.dialogReference, null);
    this.sidePanelService.open(CheckoutReviewComponent, checkoutData).subscribe();
  }
}
